import GTM from 'services/AirBaltic/GTM'

class Offers {
  static push(data) {
    GTM.doDataLayerPush(data)
  }

  static offersClicked(count) {
    this.push({
      event: 'header_events',
      generic_event_name: 'notification_icon',
      event_category: 'click',
      event_action: count
    })
  }

  static offersVisible(count) {
    this.push({
      event: 'header_events',
      generic_event_name: 'notification_icon',
      event_category: 'see',
      event_action: count
    })
  }

  static offersOpen(title, int_name) {
    this.push({
      event: 'header_events',
      eneric_event_name: 'notification_icon',
      event_category: 'read_more',
      event_action: title,
      eventLabel: int_name
    })
  }

  static offersRead(title, int_name) {
    this.push({
      event: 'header_events',
      eneric_event_name: 'notification_icon',
      event_category: 'marked_as_read',
      event_action: title,
      eventLabel: int_name
    })
  }
}

export default Offers
